import { checkPlayerName, nameErrorMessage } from '../monetization/name-filter';

export interface NameModalOptions {
  initial: string;
  title: string;
  note: string;
  onSave: (name: string) => void;
}

let activeOverlay: HTMLDivElement | null = null;

export function isNameModalOpen(): boolean {
  return activeOverlay !== null;
}

export function openNameModal(options: NameModalOptions): void {
  if (typeof document === 'undefined' || activeOverlay) {
    return;
  }

  const overlay = document.createElement('div');
  overlay.className = 'modal-overlay';

  const card = document.createElement('div');
  card.className = 'modal-card';

  const title = document.createElement('h2');
  title.className = 'modal-title';
  title.textContent = options.title;

  const note = document.createElement('p');
  note.className = 'modal-note';
  note.textContent = options.note;

  const input = document.createElement('input');
  input.className = 'modal-input';
  input.type = 'text';
  input.maxLength = 16;
  input.value = options.initial;
  input.autocomplete = 'off';
  input.spellcheck = false;
  input.setAttribute('aria-label', 'leaderboard name');

  const error = document.createElement('p');
  error.className = 'modal-error';

  const actions = document.createElement('div');
  actions.className = 'modal-actions';

  const cancel = document.createElement('button');
  cancel.type = 'button';
  cancel.className = 'modal-button ghost';
  cancel.textContent = 'cancel';

  const save = document.createElement('button');
  save.type = 'button';
  save.className = 'modal-button';
  save.textContent = 'save';

  actions.append(cancel, save);
  card.append(title, note, input, error, actions);
  overlay.append(card);
  document.body.append(overlay);
  activeOverlay = overlay;

  const validate = (): boolean => {
    const check = checkPlayerName(input.value);
    if (!check.ok) {
      error.textContent = check.reason === 'empty' ? '' : nameErrorMessage(check.reason);
      save.disabled = true;
      return false;
    }
    error.textContent = '';
    save.disabled = false;
    return true;
  };

  const close = (): void => {
    overlay.remove();
    activeOverlay = null;
  };

  const commit = (): void => {
    const check = checkPlayerName(input.value);
    if (!check.ok) {
      return;
    }
    close();
    options.onSave(check.name);
  };

  const onKeyDown = (event: KeyboardEvent): void => {
    event.stopPropagation();
    if (event.key === 'Escape') {
      event.preventDefault();
      close();
    } else if (event.key === 'Enter') {
      event.preventDefault();
      if (validate()) {
        commit();
      }
    }
  };

  overlay.addEventListener('keydown', onKeyDown);
  overlay.addEventListener('keyup', (event) => {
    event.stopPropagation();
  });
  overlay.addEventListener('pointerdown', (event) => {
    if (event.target === overlay) {
      close();
    }
  });
  input.addEventListener('input', validate);
  cancel.addEventListener('click', close);
  save.addEventListener('click', commit);

  validate();
  input.focus();
  input.select();
}
